import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { Alert, Button, PasswordField } from "../../../components/ui";
import { AuthShell } from "../../../layouts/AuthShell";
import { resetPassword } from "../api/authApi";
import { resetPasswordSchema } from "../schemas/authSchemas";

interface Values { password: string; confirmPassword: string }
export function ResetPasswordPage() {
  const { token = "" } = useParams(); const navigate = useNavigate(); const [error, setError] = useState<string>();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<Values>({ resolver: zodResolver(resetPasswordSchema), defaultValues: { password: "", confirmPassword: "" } });
  const submit = handleSubmit(async (values) => { try { await resetPassword(token, values.password, values.confirmPassword); await navigate("/login", { replace: true }); } catch { setError("重設連結無效或已過期，請重新申請。"); } });
  return <AuthShell title="設定新密碼"><>{error && <Alert variant="danger">{error}</Alert>}<form onSubmit={(event) => void submit(event)}><PasswordField label="新密碼" required error={errors.password?.message} {...register("password")} /><PasswordField label="確認密碼" required error={errors.confirmPassword?.message} {...register("confirmPassword")} /><Button type="submit" loading={isSubmitting}>更新密碼</Button></form></></AuthShell>;
}
